export * from './placeholder'
export * from './lazyload'
export * from './sns'
export * from './loadStatus'
export * from './apiPath'
export * from './error'

export enum COLOR_PATTERN_TYPES {
  PLAIN = 'plain',
  PRINT_SINGLE = 'single',
  PRINT_FULL = 'full',
  EMBROIDERY_TEXT = 'text',
  EMBROIDERY_IMAGE = 'image'
}

export const COLOR_TYPES = {
  SINGLE_COLOR: '単色印刷',
  FULL_COLOR: 'フルカラー'
}

export const COLOR_PATTERN_EXPLANATIONS = {
  'ネーム刺繍': '名入れをするなら',
  'オリジナル刺繍': 'ロゴなどの刺繍に',
  'シートプリント': '視認性がよく安価',
  'シルクプリント': '大ロットにおすすめ',
  '転写プリント': '写真やイラストに'
}

export const APP_PATH_REGEX = {
  CATEGORY: /^\/categories\/.+/,
  INDUSTRY: /^\/industries\/.+/,
  SEARCH: /^\/search/
}

export enum APP_EVENTS {
  SEARCH_KEYWORD_APPLY = 'search_keyword_apply'
}

export enum OBJECT_PUBLISH_STATUS {
  PUBLISHED = 'published',
  UNPUBLISHED = 'unpublished'
}

export const JSON_SELECTOR = {
  CURRENT_USER: '#currentUser'
}

export enum IMAGE_VARIANT_NAMES {
  BANNER_DESKTOP = 'banner_desktop',
  BANNER_MOBILE = 'banner_mobile',
  CATEGORY_LIST_ICON = 'category_list_icon',
  CATEGORY_THUMBNAIL = 'category_thumbnail',
  BRAND_THUMBNAIL = 'brand_thumbnail',
  PRODUCT_SKU_CARD = 'product_sku_card',
  PRODUCT_SKU_THUMBNAIL = 'product_sku_thumbnail',
  PRODUCT_SKU_SLIDER_THUMBNAIL = 'product_sku_slider_thumbnail',
  CMS_BANNER_CARD = 'cms_banner_card',
  CMS_BANNER = 'cms_banner'
}
